export const getAccessRoleInitialState = {
	accessRole: null,
	error: null,
	errorShow: false,
	loading: false,
};
